import { useRef } from 'react'
import { useRouter } from 'next/navigation'
import { useRipple } from '@/hooks/useRipple'

const DeliverOrderButton = () => {
  const router = useRouter()
  const ref = useRef(null)
  useRipple(ref)

  return (
    <button
      ref={ref}
      className="dark:shadow-none bg-orange-primary dark:bg-orange-darkMode hover:opacity-80 relative w-full px-2 py-2.5 mr-2 overflow-hidden font-medium text-white border border-transparent rounded shadow"
      onClick={() => router.push('/delivery')}
    >
      Continuar
    </button>
  )
}
export default DeliverOrderButton
